import IcoMoon from "react-icomoon";
import React from "react";
const iconSet = require("./selection.json");

export default function Icon({ icon, size }) {
  return <IcoMoon icon={icon} size={size} iconSet={iconSet} />;
}
